(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.gallery-section');
  if (section) {
    const track = section.querySelector('.gallery-track');
    const prevBtn = section.querySelector('.gallery-nav-prev');
    const nextBtn = section.querySelector('.gallery-nav-next');

    if (track && prevBtn && nextBtn) {
      const getScrollAmount = () => {
        const slide = track.querySelector('.gallery-slide');
        if (!slide) return 300;
        const gap = parseFloat(getComputedStyle(track).gap) || 12;
        return slide.offsetWidth + gap;
      };

      const updateButtons = () => {
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons);
      updateButtons();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
